"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _auth0React = require("@auth0/auth0-react");
var _PageLayout = require("../components/PageLayout");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Profile = () => {
  const {
    user
  } = (0, _auth0React.useAuth0)();
  // const [message, setMessage] = useState('')
  // const {user, isAuthenticated, getAccessTokenSilently} = useAuth0()

  // useEffect(() => {
  //   let isMounted = true

  //   const getMessage = async () => {
  //     const accessToken = await getAccessTokenSilently()
  //     console.log(accessToken)
  //     setMessage('blah')
  //     // const {data, error} = await getProtectedResource(accessToken)

  //     // if (!isMounted) {
  //     //   return
  //     // }

  //     // if (data) {
  //     //   setMessage(JSON.stringify(data, null, 2))
  //     // }

  //     // if (error) {
  //     //   setMessage(JSON.stringify(error, null, 2))
  //     // }
  //   }

  //   getMessage()

  //   return () => {
  //     isMounted = false
  //   }
  // }, [getAccessTokenSilently])

  return /*#__PURE__*/_react.default.createElement(_PageLayout.PageLayout, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "content-layout"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    id: "page-title",
    className: "content__title"
  }, "Profile Page"), /*#__PURE__*/_react.default.createElement("div", {
    className: "content__body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    id: "page-description"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, "User token:"))), /*#__PURE__*/_react.default.createElement("pre", null, "Token: ", JSON.stringify(user, null, 2)))));
};
exports.Profile = Profile;